<template>
  <div
    v-if="isLoggedIn"
    class="library-shows container"
    data-test="libarary-shows">
    <loader
      v-show="!podcastsLoaded"
      center
      label="Fetching Podcasts ..."/>
    <library-menu
      :display-grid="true"
      :text="totalPodcasts + ' Show' + (totalPodcasts > 1 || !totalPodcasts ? 's' : '')"/>
    <!-- Empty Shows Box -->
    <empty-shows
      v-show="!podcasts.length && podcastsLoaded"
      option="shows"/>
    <!-- Display Podcasts -->
    <div
      v-if="podcasts.length && podcastsLoaded"
      class="podcast-grid">
      <draggable
        v-model="podcasts"
        :options="draggableOptions"
        class="el-row el-row--flex d-flex-wrap"
        @end="onPodcastDragEnd">
        <el-col
          v-for="(item,index) in podcasts"
          :md="6"
          :sm="6"
          :xs="12"
          :key="item.uuid"
          class="m-t-2"
          data-test="list-shows">
          <show-card
            :podcast="item.podcast"
            :last-viewed-at="item.last_viewed_at"
            :latest-episode="item.latest_episode"
            :episode-count="item.recent_episode_count > 0"
            data-test="shows"
            @podcastClicked="updatePodcastLastViewedAt(item, index)"
          />
        </el-col>
      </draggable>
      <div class="t-c">
        <el-button
          v-if="!loadingMoreShows && !noMoreShows"
          class="btn-transparent large"
          data-test="load-more"
          @click="getPodcastsFromLibrary">Load More</el-button>
      </div>
      <loader
        v-show="loadingMoreShows && !noMoreShows"
        :with-margin="true"/>
    </div>
  </div>
</template>
<script>
import * as log from 'loglevel';
import draggable from 'vuedraggable';
import Podcast from '../../services/Podcast';
import User from '../../services/User';
import SegmentEvent from '../../services/PlayerEvent';
import ScrollMixin from '../../shared/scrollMixin';
import PageMixin from '../../shared/pageMixin';

export default {
  name: 'Shows',
  components: {
    draggable,
    loader: () => import('../../components/Loader'),
    'show-card': () => import('../../components/ShowCard'),
    'empty-shows': () => import('../../components/EmptyShows'),
    'library-menu': () => import('../../components/LibraryMenu'),
  },
  mixins: [ScrollMixin, PageMixin],
  data() {
    return {
      pageName: 'My Shows',
      podcastService: new Podcast(),
      userService: new User(),
      totalPodcasts: 0,
      podcasts: [],
      showLimit: 12,
      page: 0,
      isLoggedIn: this.$store.getters.loggedIn,
      podcastsLoaded: false,
      noMoreShows: false,
      loadingMoreShows: false,
      draggableOptions: {
        animation: 500,
        ghostClass: 'ghost',
        chosenClass: 'chosen',
        dragClass: 'drag',
        delay: 10,
        scrollSensitivity: 100,
        scrollSpeed: 10,
        scroll: true,
        forceFallback: true,
        direction: 'horizontal',
      },
      eventProvider: new SegmentEvent(),
      bucket: {},
    };
  },
  beforeMount() {
    if (this.isLoggedIn) {
      this.getPodcastsFromLibrary();
    }
    if (window && window.innerWidth <= this.screenSize.sm) {
      this.draggableOptions.delay = 200;
    }
  },
  mounted() {
    this.bucket = {
      bucket_uuid: null,
      name: 'My Shows',
      bucket_type: 'podcasts',
      position: 0,
      media_size: 'thumbnail',
    };
  },
  methods: {
    getPodcastsFromLibrary() {
      this.loadingMoreShows = true;
      if (this.noMoreShows) {
        this.podcastsLoaded = true;
        return;
      }
      this.podcastService.getPodcastsFromLibrary(this.showLimit, ++this.page)
        .then((pods) => {
          this.totalPodcasts = pods.total;
          this.podcasts = this.podcasts.concat(pods.podcasts || []);
          this.loadingMoreShows = false;
          this.noMoreShows = this.podcasts.length >= pods.total;
          this.podcastsLoaded = true;
          this.mapPodcastDataIntoLatestEpisodeData();
          this.contentList = this.podcasts.map(userPodcast => userPodcast.podcast);
        })
        .catch((err) => { log.warn(err.message); });
    },
    onPodcastDragEnd(evt) {
      if (evt.oldIndex !== evt.newIndex) {
        this.updatePodcastPosition(this.podcasts[evt.newIndex], evt.newIndex + 1);
      }
    },
    updatePodcastLastViewedAt(userPodcast, podcastPosition) {
      this.podcastService.updatePodcastViewDate(userPodcast.uuid).then().catch((err) => { log.warn(err.message); });

      const bucketItemData = { ...userPodcast.podcast };
      bucketItemData.item_position = podcastPosition;
      this.eventProvider.triggerContentSelectEvent(this.bucket, bucketItemData);
    },
    // TODO: implement this method in the UI
    deletePodcastFromLibrary(uuid) {
      this.podcastService.deletePodcastFromLibrary(uuid).then().catch((err) => { log.warn(err.message); });
    },
    updatePodcastPosition(userPodcast, pos) {
      this.podcastService.updatePodcastPosition(userPodcast.uuid, pos)
        .then((res) => {
          if (res && res.success) this.eventProvider.triggerMyShowsReorderEvent(userPodcast.podcast.uuid, res.new_position, pos);
        })
        .catch((err) => { log.warn(err.message); });
    },
    mapPodcastDataIntoLatestEpisodeData() {
      for (let i = 0; i < this.podcasts.length; i++) {
        if (this.podcasts[i] && this.podcasts[i].uuid && this.podcasts[i].latest_episode) {
          this.podcasts[i].latest_episode.season = {
            podcast: this.podcasts[i].podcast,
          };
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.library-shows {
  min-height: calc(100vh - 347px);
  .top-bar {
    margin: 0 0;
  }
  .ghost {
    opacity: 0 !important;
  }
}
@media (max-width: 576px) {
  .library-shows {
    .top-bar {
      padding-bottom: 0 !important;
      margin: 0 5px !important;
    }
    .container {
      width: 100%;
    }
  }
}
</style>
